import React from 'react';
import './Brands.css';
import { brandsData } from './BrandsData';

const Brands = () => {
  return (
    <section className='brands-section'>
      <div className='brands-container'>
        {brandsData.map((category, index) => (
          <div key={index} className='brand-card'>
            <h3 className='brand-category-title'>{category.title}</h3>
            <p className='brand-category-desc'>{category.description}</p>
            <div className='brand-logos-grid'>
              {category.brands.map((brand, idx) => (
                <div key={idx} className='brand-logo-item'>
                  {brand.url ? (
                    <a
                      href={brand.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='brand-link'
                      aria-label={`${brand.name} (opens in a new tab)`}
                    >
                      {brand.svg ? brand.svg : brand.name}
                    </a>
                  ) : brand.svg ? (
                    brand.svg
                  ) : (
                    brand.name
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Brands;
